import React, { Component } from 'react'
import propTypes from 'prop-types'
import { observer } from 'mobx-react'
import { extendObservable } from 'mobx'

class Radio extends Component {
  static propTypes = {
    checked: propTypes.bool,
    onChange: propTypes.func,
    disabled: propTypes.bool
  }

  constructor (props) {
    super(props)

    extendObservable(this, {
      checked: props.checked || false
    })
  }

  handleChange = () => {
    this.checked = !this.checked
    const { onChange } = this.props
    if (onChange) onChange(this.checked)
  }

  render () {
    const { checked, disabled } = this.props

    return (
      <div
        className='radio-input'
        onClick={!disabled ? this.handleChange : null}
      >
        {checked && !disabled ? <div className='radio-input__dot' /> : null}
      </div>
    )
  }
}

export default observer(Radio)
